// Functions used in combination with the .filter func for arrays.
// Therefore the usual use case looks something like
// array.filter(someOperation()) or

type Falsy = false | 0 | 0n | "" | null | undefined;

// Narrows out null/undefined/falsy values
export function defined<T>(): (t: T) => t is Exclude<T, Falsy> {
  return (t: T): t is Exclude<T, Falsy> => !!t;
}

export type ExistsInOptions<T, P, R> = {
  byFirst?: (t: T) => R;
  bySecond?: (p: P) => R;
};
export function existsIn<T, R = T>(
  arr: readonly T[],
  by?: (r: T) => R
): (t: T) => boolean {
  const set = new Set<unknown>(by ? arr.map(by) : arr);
  return (t: T) => set.has((by ? by(t) : t) as R);
}

export function isTruthy<T>(t?: T): t is T {
  return !!t;
}
